<template>
  <div id="estacoes">
    <vue-headful :title="$store.state.option['stations_title-' + lang]" :lang="lang" />
    <titulo></titulo>
    <div class="b-cinzento p-20">
        <select class="form-control" style="width:400px;margin-left: calc(50% - 200px)" v-model="estacao" @change="estacaoFN()">
          <option disabled>{{$store.state.option['estacao-' + lang]}}</option>
          <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
        </select>
    </div>

    <div v-if="estacao">
      <div class="container">
        <div class="row no-gutters p-v-60">
          <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4">
            <!-- Icon Blocks -->
            <div class="g-py-20 text-center">
              <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                  <i class="laranja fas fa-map"></i>
                </div>
              <div class="text-center">
                <span class="d-block">{{estacaoInfo.Address1}}&nbsp;{{estacaoInfo.Address2}}</span>
                <span class="d-block">{{estacaoInfo.PostalCode}}&nbsp;{{estacaoInfo.City}}</span>
                <span class="d-block">{{paises(estacaoInfo.Country)}}</span>
                <span class="d-block">Latitude: {{estacaoInfo.Latitude}}</span>
                <span class="d-block">Longitude: {{estacaoInfo.Longitude}}</span>
              </div>
            </div>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4">
            <!-- Icon Blocks -->
            <div class="g-py-20 text-center">
              <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                  <i class="laranja fas fa-phone"></i>
              </div>
              <div class="text-center">
                <span class="d-block" v-if="estacaoInfo.Phone1">
                  <a class="a-cor" :href="'tel:' + estacaoInfo.Phone1">{{estacaoInfo.Phone1}}</a><br />
                </span>
                <span class="d-block" v-if="estacaoInfo.Phone2">
                  <a class="a-cor" :href="'tel:' + estacaoInfo.Phone2">{{estacaoInfo.Phone2}}</a><br />
                </span>
                <span class="d-block" v-if="estacaoInfo.CellPhone">
                  <a class="a-cor" :href="'tel:' + estacaoInfo.CellPhone">{{estacaoInfo.CellPhone}}</a>
                </span>
              </div>
            </div>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4" v-if="estacaoInfo.Email">
            <!-- Icon Blocks -->
            <div class="g-py-20 text-center">
              <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                  <i class="laranja fas fa-envelope"></i>
              </div>
              <div class="text-center">
                <span class="d-block">
                  <a class="a-cor d-block text-center" :href="'mailto:' + estacaoInfo.Email">{{estacaoInfo.Email}}</a>
                </span>
              </div>
            </div>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-md-3 col-lg-3">
            <!-- Icon Blocks -->
            <div class="g-py-20 text-center">
              <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja far fa-clock"></i>
              </div>
              <div class="text-center">
                <span class="d-block" v-if="currentSeasonInfo.MondayOpen || currentSeasonInfo.MondayClose">
                  {{$store.state.option['monday-' + lang]}} {{currentSeasonInfo.MondayOpen}} <span v-if="currentSeasonInfo.MondayLunchStart.indexOf(':') > 0"> - {{currentSeasonInfo.MondayLunchStart}} | </span> <span v-if="currentSeasonInfo.MondayLunchEnd.indexOf(':') > 0"> {{currentSeasonInfo.MondayLunchEnd}} </span> - {{currentSeasonInfo.MondayClose}}<br />
                </span>
                <span class="d-block" v-if="currentSeasonInfo.TuesdayOpen || currentSeasonInfo.TuesdayClose">
                  {{$store.state.option['tuesday-' + lang]}} {{currentSeasonInfo.TuesdayOpen}} <span v-if="currentSeasonInfo.TuesdayLunchStart.indexOf(':') > 0"> - {{currentSeasonInfo.TuesdayLunchStart}} | </span> <span v-if="currentSeasonInfo.TuesdayLunchEnd.indexOf(':') > 0"> {{currentSeasonInfo.TuesdayLunchEnd}} </span> - {{currentSeasonInfo.TuesdayClose}}<br />
                </span>
                <span class="d-block" v-if="currentSeasonInfo.WednesdayOpen || currentSeasonInfo.WednesdayClose">
                  {{$store.state.option['wednesday-' + lang]}} {{currentSeasonInfo.WednesdayOpen}} <span v-if="currentSeasonInfo.WednesdayLunchStart.indexOf(':') > 0"> - {{currentSeasonInfo.WednesdayLunchStart}} | </span> <span v-if="currentSeasonInfo.WednesdayLunchEnd.indexOf(':') > 0"> {{currentSeasonInfo.WednesdayLunchEnd}} </span> - {{currentSeasonInfo.WednesdayClose}}<br />
                </span>
                <span class="d-block" v-if="currentSeasonInfo.ThursdayOpen || currentSeasonInfo.ThursdayClose">
                  {{$store.state.option['thursday-' + lang]}} {{currentSeasonInfo.ThursdayOpen}} <span v-if="currentSeasonInfo.ThursdayLunchStart.indexOf(':') > 0"> - {{currentSeasonInfo.ThursdayLunchStart}} | </span> <span v-if="currentSeasonInfo.ThursdayLunchEnd.indexOf(':') > 0"> {{currentSeasonInfo.ThursdayLunchEnd}} </span> - {{currentSeasonInfo.ThursdayClose}}<br />
                </span>
                <span class="d-block" v-if="currentSeasonInfo.FridayOpen || currentSeasonInfo.FridayClose">
                  {{$store.state.option['friday-' + lang]}} {{currentSeasonInfo.FridayOpen}} <span v-if="currentSeasonInfo.FridayLunchStart.indexOf(':') > 0"> - {{currentSeasonInfo.FridayLunchStart}} | </span> <span v-if="currentSeasonInfo.FridayLunchEnd.indexOf(':') > 0"> {{currentSeasonInfo.FridayLunchEnd}} </span> - {{currentSeasonInfo.FridayClose}}<br />
                </span>
                <span class="d-block" v-if="currentSeasonInfo.SaturdayOpen || currentSeasonInfo.SaturdayClose">
                  {{$store.state.option['sabado-' + lang]}} {{currentSeasonInfo.SaturdayOpen}} <span v-if="currentSeasonInfo.SaturdayLunchStart.indexOf(':') > 0"> - {{currentSeasonInfo.SaturdayLunchStart}} | </span> <span v-if="currentSeasonInfo.SaturdayLunchEnd.indexOf(':') > 0"> {{currentSeasonInfo.SaturdayLunchEnd}}</span> - {{currentSeasonInfo.SaturdayClose}}<br />
                </span>
                <span class="d-block" v-if="currentSeasonInfo.SundayOpen || currentSeasonInfo.SundayClose">
                  {{$store.state.option['domingo-' + lang]}} {{currentSeasonInfo.SundayOpen}} <span v-if="currentSeasonInfo.SundayLunchStart.indexOf(':') > 0"> - {{currentSeasonInfo.SundayLunchStart}} | </span> <span v-if="currentSeasonInfo.SundayLunchEnd.indexOf(':') > 0"> {{currentSeasonInfo.SundayLunchEnd}}</span> - {{currentSeasonInfo.SundayClose}}<br />
                </span>
                <span class="d-block" v-if="estacaoInfo.HolidayOpen || estacaoInfo.HolidayClose">
                  {{$store.state.option['feriados-' + lang]}} {{estacaoInfo.HolidayOpen}} <span v-if="estacaoInfo.HolidayLunchIni.indexOf(':') > 0"> - {{estacaoInfo.HolidayLunchIni}} | </span> <span v-if="estacaoInfo.HolidayLunchFim.indexOf(':') > 0"> {{estacaoInfo.HolidayLunchFim}}</span> - {{estacaoInfo.HolidayClose}}<br />
                </span>
              </div>
            </div>
            <!-- End Icon Blocks -->
          </div>
        </div>
      </div>

      <!--<div id="googleMap" v-if="$store.state.option.googleMaps && estacaoInfo.Latitude && estacaoInfo.Longitude && position">
        <GmapMap :center="center" :zoom="14">
          <GmapMarker :position="position" style="height: 300px"/>
        </GmapMap>
      </div>-->
      <div v-if="$store.state.option.googleMaps && estacaoInfo.Latitude && estacaoInfo.Longitude">
        <GmapMap :center="{ lat: +estacaoInfo.Latitude, lng: +estacaoInfo.Longitude }" :zoom="14" style="height: 300px">
          <GmapMarker :position="google && new google.maps.LatLng(+estacaoInfo.Latitude, +estacaoInfo.Longitude)" style="height: 300px"/>
        </GmapMap>
      </div>

      <div class="container m-b-30 m-t-30">
        <div class="container1 pr text-center"><div class="barra"></div><h2 class="text-center text-uppercase laranja p-t-20 z-10 pr b-branco titulo preto">{{$store.state.option['viaturas-' + lang]}}</h2></div>
        <div class="row p-v-20">
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 box" v-for="(dt, index) in carros" :key="index">
            <div class="card float-left p-0 m-0 full-width">
              <div style="height:190px; line-height:190px;text-align:center;">
                <img :src="dt.imageURL ? dt.imageURL : '/img/img.png'" class="card-img-top" :alt="dt.brand + ' ' + dt.model" />
              </div>
              <div class="card-body text-center">
                <h5 class="card-title m-0">{{dt.brand}} {{dt.model}}</h5>
                <p class="card-text">{{dt.group_Name}}</p>

                <div class="text-center p-t-5">
                  <span class="car-icon bg-icon_driver">{{dt.seats}}</span>
                  <span class="car-icon bg-icon_door">{{dt.doors}}</span>
                  <span class="car-icon bg-icon_bag">{{dt.suitcases}}</span>
                  <span class="car-icon bg-icon_transmissao text-uppercase" v-if="dt.automaticTransmission == true">{{$store.state.option['automatic-' + lang][0]}}</span>
                <span class="car-icon bg-icon_transmissao text-uppercase" v-else>{{$store.state.option['manual-' + lang][0]}}</span>
                </div>

                <div class="clearfix m-t-10"></div>
                <router-link class="btn btn-primary btn-block text-uppercase box-a" to="/reserved">{{$store.state.option['car_reservar-' + lang]}} <i class="far fa-check-circle"></i></router-link>
                <!-- <router-link class="btn btn-primary btn-block text-uppercase box-a" :to="'/reserved?l=' + estacao + '&d=' + estacao">{{$store.state.option['reservar1-' + lang]}} <i class="far fa-check-circle"></i></router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="container">
      <div class="row p-v-20">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" v-for="(dt, index) in res" :key="index">
          <div @click="$router.push('/station/' + dt.StationID)" class="card mao float-left p-0 m-0 full-width">
            <img :src="dt.capa ? '/images/' + dt.capa : '/img/img.png'" class="card-img-top" :alt="dt.Station">
            <div class="card-body text-center">
              <h5 class="card-title">{{dt.Station}}</h5>
              <p class="card-text">{{dt.City}}</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import titulo from '@/components/titulo'
import { loadGmapApi, gmapApi } from 'vue2-google-maps'

export default {
  components: { titulo },
  data () {
    return {
      estacoes: [],
      estacao: '',
      estacaoInfo: {},
      carros: [],
      lang: '',
      dateNow: new Date().setDate(new Date().getDate()),
      currentSeasonInfo: {}
    }
  },
  computed: {
    google: gmapApi
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_LOAD1',
      'SET_MAP'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.stations1 && this.$store.state.paises1) {
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['stations_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['stations_subtitle-' + this.lang])
        this.estacoes = this.$store.state.stations
        this.estacao = this.$store.state.stations[0].StationID
        if (!this.$store.state.mapa) {
          this.SET_MAP(true)
          loadGmapApi({
            key: this.$store.state.option['googleMaps'],
            libraries: 'places'
          })
        }
        this.estacaoFN()
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    },

    estacaoFN () {
      this.SET_LOAD1(true)
      this.axios.get('/stations/' + this.estacao).then((res) => {
        this.estacaoInfo = res.data[0]
        // // check the season which we need to look for the data about station's schedule
        this.currentSeasonInfo = this.getCurrentSeasonObject(this.dateNow, this.estacaoInfo.Schedule)
        console.log(this.estacaoInfo)
        this.axios.get('/cars/station/' + this.estacao).then((res) => {
          this.carros = res.data
          this.SET_LOAD1()
        }, (er) => {
          this.$router.replace('/404', () => {})
        })
      }, (er) => {
        this.$router.replace('/404', () => {})
      })
    },

    paises (pais) {
      let p = this.$store.state.paises.find(a => +a.countryID === +pais)
      if (p) {
        return p.country
      }
      return ''
    },

    parseDate (dateStr, year) {
      // Split date and time
      let [datePart, timePart] = dateStr.split(' ') // "dd/mm hh:mm"
      // Parse day and month
      let [day, month] = datePart.split('/').map(Number)
      // Parse hours and minutes (default to 00:00 if time is not provided)
      let [hours, minutes] = timePart ? timePart.split(':').map(Number) : [0, 0]
      // Return a full Date object with time
      return new Date(year, month - 1, day, hours, minutes)
    },

    getCurrentSeasonObject (currentDate, data) {
      for (let obj of data) {
        let currentYear = new Date(currentDate).getFullYear()
        let seasonStart = this.parseDate(obj.SeasonStart, currentYear)
        let seasonEnd = this.parseDate(obj.SeasonEnd + ' 23:59', currentYear)

        if (seasonStart <= currentDate && currentDate <= seasonEnd) {
          return obj
        }
      }
      return null
    }
  }
}
</script>
